import * as actionTypes from '../actions/actionTypes';

const initialState = {
  showModal: false,
  message: '',
};

const warningModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPEN_WARNING_MODAL:
      return {
        ...state,
        showModal: true,
        message: action.message,
        showLoader:action.showLoader
      };
    case actionTypes.CLOSE_WARNING_MODAL:
      return {
        ...state,
        showModal: false,
        message: '',
        showLoader:action.showLoader
      };
    default:
      return {
        ...state,
      };
  }
};
export default warningModalReducer;
